import scrollMainPage from "./scroll_main_page"

// wariant :mobile (meta app_variant z ApplicationHelper#app_variant) - kółko myszy nad navbarem/sidebarem przewija <main>
const appVariant = document.head.querySelector("meta[name=\"app_variant\"]")?.content

if (appVariant === "mobile") { scrollMainPage() }
